import AxiosInstance from './AxiosInstance';

/**
 *
 * @param idempotencyId is the PageName
 */
const AxiosInstanceUserFeedback = () =>
  AxiosInstance(process.env.API_USER_FEEDBACK_URL ?? '');
export default AxiosInstanceUserFeedback;
